import Cookies from 'js-cookie'

// initial state
const state = {
    popupTitle: '',
    simpleDescription: '',
    backgroundDarkness: 'rgba(0, 0, 0, 0.75)',
    allBoxesCheckboxStatus: false,
    showPopup: false,
    activeTheme: '',
    completeState: false,
    highlightCheckAll: false,
    consentPackage: [
        {
            name: 'Cookie Consent',
            version: ''
        }
    ],
    consentItems: [
        {
            name: 'Functional cookies',
            required: true,
            active: false,
            showRequired: false,
            showInfo: false,
            consentInfo: [
                {
                    title: 'Authorization',
                    desc: 'We use an authorization cookie to see if you are a guest or a user.'
                },
                {
                    title: 'Malfeasance',
                    desc: 'Lorem ipsum dolor sit amet, dolorem nusquam qui at, idque eripuit equidem vim ex.'
                }
            ]
        },
        {
            name: 'Analytics cookies',
            required: false,
            active: false,
            showRequired: false,
            showInfo: false,
            consentInfo: [
                {
                    title: 'Google Analytics',
                    desc: 'Lorem ipsum dolor sit amet, dolorem nusquam qui at, idque eripuit equidem vim ex.'
                }
            ]
        },
        {
            name: 'Marketing cookies',
            required: false,
            active: false,
            showRequired: false,
            showInfo: false,
            consentInfo: [
                {
                    title: 'Personal offers',
                    desc: 'Lorem ipsum dolor sit amet, dolorem nusquam qui at, idque eripuit equidem vim ex.'
                }
            ]
        }
    ]
};

// getters
const getters = {
    //all active items, including required ones
    allItemsActive: state => {
        return state.consentItems.filter(item => item.active);
    },

    //total of items that are not required
    unrequiredItemsCount: state => {
        return state.consentItems.filter(item => !item.required).length;
    },

    //total of items that are active but not required
    unrequiredActiveCount: state => {
        return state.consentItems.filter(item => item.active && !item.required).length;
    },

    //all items that are required but not active
    requiredInactive: state => {
        return state.consentItems.filter(item => item.required && !item.active);
    }
};

// mutations
const mutations = {
    setPackageInfo(state, payload) {
        state.activeTheme = payload.pop_up_theme;
        state.popupTitle = payload.popup_name;
        state.simpleDescription = payload.pop_up_desc;
        state.consentPackage[0].version = payload.version;
    },

    toggleCheckbox(state, payload) {
        payload.active = !payload.active;
    },

    setCompletionStatus(state, payload) {
        state.completeState = payload;
    },

    togglePopup(state) {
        state.showPopup = !state.showPopup;
    },

    checkAllBoxes(state, payload) {
        state.allBoxesCheckboxStatus = payload;

        if(payload === true) {
            $.each(state.consentItems, function(key, item) {
                item.active = true;
            });
        }
    },

    setCheckAllHighlight(state, payload) {
        state.highlightCheckAll = payload;
    },

    toggleRequiredPopup(state, payload) {
        //if an item was send
        if(payload) {
            //get its name
            var cookieName = payload.name;

            //hide all 'required mesages' except for the one that is clicked on
            $.each(state.consentItems, function(key, item) {
                item.showInfo = false;

                if(cookieName !== item.name) {
                    item.showRequired = false;
                }
            });

            payload.showRequired = !payload.showRequired;
        } else {
            $.each(state.consentItems, function(key, item) {
                item.showInfo = false;
                item.showRequired = false;
            });
        }
    },

    toggleInfo(state, payload) {
        var cookieName = payload.name;

        $.each(state.consentItems, function(key, item) {
            item.showRequired = false;

            if(cookieName !== item.name) {
                item.showInfo = false;
            }
        });

        payload.showInfo = !payload.showInfo;
    }
};

// actions
const actions = {
    //function to retrieve and set popup package data
    getConsentPackage(context) {
        window.axios.get('/get_cookie_package')
            .then(response => {
                    if(response.data) {
                        context.commit('togglePopup');
                        context.commit('setPackageInfo', response.data);
                    }
                }
            );
    },

    //function to compare the current popup package version against the one consented for
    getConsentPackageVersion(context, version) {
        window.axios.get('/get_cookie_package_version')
            .then(response => {
                    if(response.data) {
                        //compare the version with the one that has been consented for
                        if(response.data.version !== version) {
                            //delete old cookie
                            Cookies.remove('consent-v2-dismissed');

                            //reload the page (so scripts don't get loaded)
                            location.reload();

                            //get the new package
                            //this.dispatch('cookiepopup/getConsentPackage');
                        }
                    }
                }
            );
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}